/**
 * Styled Components - Created by gustavomedina on 18/04/18.
 */
import styled from 'styled-components'
import AntdButton from 'antd/lib/button'
import InputComponent from 'antd/lib/input'
import InputPassword from 'antd/lib/input/Password'
import {
  GREEN,
  WHITE,
  BLUE_BRIGHT,
  GRAY_HEADER,
  GRAY_SKELETON,
  BLUE,
  GRAY_DARK,
  RED,
  BLUE_LIGHTEST,
  BLACK_BG
} from '../../theme/colors'
import Icon from 'antd/lib/icon'
import Select from 'antd/lib/select'

type DivProps = {
  onDemandMode?: boolean
  open?: boolean
  left?: boolean
  secondary?: boolean
  special?: boolean
}

type ContainerProps = {
  closed?: boolean
}

export const MainContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 20px;
  @media (max-width: 698px) {
    margin-top: 0px;
  }
`

export const DarkBg = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.7);
  z-index: 10;
`

export const ClosedBanner = styled.div`
  position: fixed;
  background-color: ${BLUE_LIGHTEST};
  left: 0;
  right: 0;
  top: 35%;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  font-size: 18px;
  padding: 20px;

  a {
    color: ${BLUE};
  }
`

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  background-color: ${WHITE};
  max-width: 1452px;
  width: 100%;
  margin: 0 auto;
  padding: 10px 50px 0;
  box-shadow: 0px 12px 14px 4px #c9c9c9;
  ${({ secondary }: DivProps) => secondary ? `
    padding-top: 0;
    .mainContainer {
      margin-top: 0px;
    }
  ` : ''}
  @media (min-width: 320px) and (max-width: 748px) {
    padding: 0;
  }
`

export const TopContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  @media (max-width: 768px) {
    flex-flow: row;
    align-items: flex-start;
  }
  @media (max-width: 698px) {
    flex-flow: column-reverse;
    align-items: center;
  }
`
export const SideBar = styled.div`
  min-width: 268px;
  @media (max-width: 698px) {
    display: none;
  }
`

export const Description = styled.div`
  text-align: center;
  padding: 0 8px;
  @media (max-width: 425px) {
    margin-left: 0;
  }
`
export const Title = styled.div`
  color: ${GRAY_DARK};
  font-size: 24px;
  font-weight: bold;
  letter-spacing: 0.3px;
  line-height: 33px;
  text-transform: uppercase;
  padding-right: 10px;
  text-align: center;
  margin-bottom: 0;
  @media (max-width: 800px) {
    margin-top: 8px;
  }
`

export const AboutTitle = styled.div`
  color: ${GRAY_DARK};
  font-size: 24px;
  fony-family: Avenir;
  font-weight: bold;
  letter-spacing: 0.3px;
  line-height: 33px;
  text-transform: uppercase;
  text-align: center;
  margin-bottom: 30px;
  position: absolute;
  top: -34px;
  left: calc(50vw - 148px);
  background: white;
  width: fit-content;
  margin: 0 auto;
  padding: 1px 32px;
  font-size: 15px;
  border-top-left-radius: 25px;
  border-top-right-radius: 25px;
  box-shadow: 0px -1px 4px -1px #828282;
  display: flex;
  align-items: center;
  padding-right: 18px;
  transition: all .25s;
  left: 50%;
  margin-right: -50%;
  transform: translateX(-50%);
  &:hover {
    cursor: pointer;
    opacity: 0.8;
  }
  @media (max-width: 698px) {
    box-shadow: 0px -1px 4px -1px #646464;
  }
  animation: fade-in-bottomfaq 0.35s cubic-bezier(0.390, 0.575, 0.565, 1.000) both;
  @keyframes fade-in-bottomfaq {
    0% {
      transform: translateY(10px) translateX(-50%);
      opacity: 0;
    }
    100% {
      transform: translateY(0) translateX(-50%);
      opacity: 1;
    }
  }
`

export const StickyArrow = styled(Icon)`
  margin-left: 12px;
  font-size: 16px;
  border-radius: 25px;
  background: #a19ec7;
  color: white;
  padding: 2px;
  padding-top: 1px;
`

export const StoreBox = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 200px;
  margin-bottom: 12px;
  height: 51px;
  border: 2px solid ${({ open }: DivProps) => (open ? GREEN : '#fecdcf')};
  background-color: ${({ open }: DivProps) => (open ? WHITE : '#fecdcf')};
  border-radius: 3px;
  color: ${({ open }: DivProps) => (open ? GREEN : '#4c0514')};
  font-family: Avenir Next;
  font-size: 18px;
  font-weight: bold;
  letter-spacing: 0.23px;
  line-height: 25px;
  text-align: center;
  z-index: 2;
  @media (max-width: 768px) {
    width: 147px;
    height: 42px;
  }
  @media (max-width: 698px) {
    width: 100%;
    height: 42px;
    background-color: #fecdcf;
    border: none;
    color: #4c0514;
    font-weight: 600;
  }
`

export const GracePeriod = styled.div`
  background: #98d392;
  padding: 7px 10px;
  border-bottom-left-radius: 12px;
  border-bottom-right-radius: 12px;
  margin-top: -14px;
  z-index: 1;
  color: ${WHITE};
`

export const ErrorTitle = styled.div`
  font-size: 18px;
  line-height: 33px;
  text-align: center;
  margin-top: 50px;
  margin-bottom: 50px;
  height: 70vh;
  align-items: center;
  justify-content: center;
  display: flex;
  flex-flow: column;

  a {
    color: ${BLUE};
  }
`

export const NoStore = styled.img`
  max-width: 360px;
  margin-bottom: 10px;
`

export const StickyFAQ = styled.div`
  padding: 0 100px;
  position: fixed;
  top: 100vh;
  background: white;
  width: 100%;
  left: 0;
  z-index: 2;
  transition: all .25s;
  ${({ secondary }: DivProps) => secondary ? `
    padding: 0px 100px;
    position: fixed;
    top: unset;
    bottom: 0;
    background: white;
    width: 100%;
    left: 0;
    z-index: 2;
  ` : ''}
`

export const AboutContainer = styled.div`
  padding: 30px;
  padding-bottom: 10px;
  max-width: 1148px;
  margin: 0 auto;
  @media (max-width: 698px) {
    padding-bottom: 110px;
  }
`

export const OrderTitle = styled.div`
  color: ${GRAY_DARK};
  font-size: 14px;
  font-weight: 600;
  letter-spacing: 0.1px;
  line-height: 19px;
  text-align: center;
  margin-bottom: 22px;
  max-width: 267px;
  @media (max-width: 698px) {
    font-size: 12px;
    line-height: unset;
    max-width: unset;
    margin-bottom: unset;
  }
`

type TitleProps = {
  center?: boolean
}

export const PriceTitle = styled.div`
  color: ${GRAY_DARK};
  font-size: 21px;
  font-weight: 600;
  letter-spacing: 0.11px;
  line-height: 23px;
  text-transform: uppercase;
  text-align: ${({ center }: TitleProps) => (center ? 'center' : 'left')};
  @media (max-width: 698px) {
    display: none;
    height: 0px;
  }
`

export const Bulletin = styled.div`
  display: inline-flex;
  max-width: 570px;
  width: 100%;
  background: ${GRAY_HEADER};
  position: relative;
  min-height: 57px;
  margin: 12px auto 0;

  padding: 14px 12px;
  justify-content: center;
  align-items: center;
  font-size: 18px;
  color: ${BLUE_BRIGHT};
  font-style: italic;
  font-family: 'Avenir-Medium';
  @media (max-width: 698px) {
    margin-top: 0px;
  }
`

export const PricesButton = styled.div`
  color: ${BLUE};
  width: 200px;
  text-align: center;
  margin-top: 10px;
  cursor: pointer;
  margin: 10px auto 0px;
  z-index: 2;
  @media (max-width: 698px) {
    margin-top: 0px;
  }
`

export const BulletinLabel = styled.span`
  white-space: pre-line;
  text-align: center;
  @media (max-width: 698px) {
    font-size: 12px;
  }
`

export const Pin = styled.img`
  transform: ${({ left }: DivProps) => (left ? 'scaleX(-1)' : 'none')};
`

export const PinDiv = styled.div`
  position: absolute;
  top: -7px;
  width: 102%;
  justify-content: space-between;
  display: flex;
`

export const Corner = styled.div`
  width: 0;
  height: 0;
  right: 0;
  bottom: 0;
  position: absolute;
  border-bottom: 16px solid ${WHITE};
  border-left: 16px solid ${GRAY_SKELETON};
`
export const PriceDropContainer = styled.div`
  @media (max-width: 698px) {
    background-color: #e6e6e6;
    margin: 0 -10px;
    padding: 10px;
  }
`

export const PriceDescription = styled.div`
  padding-top: 10px;
  color: ${GRAY_DARK};
  font-size: 16px;
  letter-spacing: 0.11px;
  line-height: 23px;
  @media (max-width: 698px) {
    display: none;
  }
`

export const PriceDescriptionMobile = styled.div`
  display: none;
  padding-top: 10px;
  color: ${GRAY_DARK};
  letter-spacing: 0.11px;
  font-size: 14px;
  text-align: justify;
  line-height: 18px;
  @media (max-width: 698px) {
    display: block;
  }
`

export const ShowMore = styled.span<{$withMargin?: boolean}>`
  color: #4A90E2
  font-size: 12px;
  margin-left: ${props => props.$withMargin ? '6px' : 'unset'};
`

export const Text = styled.div`
  color: #fff;
`

export const ButtonWrapper = styled.div`
  padding-right: 10px;
  .ant-btn-primary {
    background-color: ${BLUE};
    border-color: ${BLUE};
    width: 70px;
  }
  .ant-btn-primary:hover {
    background-color: ${BLUE};
    border-color: ${BLUE};
  }
`

export const Button = styled(AntdButton)`
  height: 40px;
  width: 70px;
`

export const DefaultButton = styled(AntdButton)`
  height: 40px;
  ${({ closed }: ContainerProps) => closed ? `
    background: ${RED};
    color: white;
    border-color: ${RED};
    box-shadow: 1px 1px 3px 1px #b4b4b4;
  ` : ''}
  @media (max-width: 698px) {
    padding: 6px;
  }
`

export const TextBanner = styled.div`
  display: none;
  justify-content: center;
  background: linear-gradient(112.1deg, rgb(32, 38, 57) 11.4%, rgb(63, 76, 119) 70.2%);
  color: ${WHITE}
  padding: 24px;
  font-size: 18px;
  font-weight: 600;
  margin: 0px;
  @media (max-width: 698px) {
    display: flex;
  }
`

export const ImageBanner = styled.img`
  max-height: 300px;
  max-width: 1452px;
  margin: 0 auto 10px;
  width: 100%;
  object-fit: cover;
  @media (max-width: 698px) {
    max-height: 120px;
    margin-bottom: 0;
  }
`

export const CalendarView = styled.div`
  height: 78px;
  width: 81px;
  margin-right: 7px;
  margin-left: 7px;
  border: 2px solid #8c8c8c;
  border-radius: 2px;
  max-width: 80px;
  width: 100%;
  @media (max-width: 698px) {
    margin-right: 5px;
    flex-grow: 1;
    height: 50px;
    width: fit-content;
  }
`

export const CalendarFinalView = styled.div`
  height: 78px;
  margin-right: 7px;
  margin-left: 7px;
  border: 2px solid ${RED};
  border-radius: 2px;
  max-width: 80px;
  width: 100%;
  @media (max-width: 698px) {
    margin-left: 5px;
    flex-grow: 1;
    height: 50px;
    width: fit-content;
  }
`

export const CalendarTitle = styled.div`
  text-align: center;
  width: 100%;
  height: 20px;
  color: ${WHITE};
  background-color: #8c8c8c;
  text-transform: uppercase;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 4px 8px;
  font-size: 12px;
  @media (max-width: 698px) {
    height: 18px;
    font-size: 10px;
    padding: 0px 4px;
  }
`

export const CutOffDiv = styled.div`
  margin-top: 7px;
  font-size: 10px;
  margin-bottom: -10px;
  @media (max-width: 698px) {
    font-size: 12px;
  }
`

export const CutOffTime = styled.div`
  margin-top: 18px;
  font-size: 10px;
  max-width: 174px;
  @media (max-width: 698px) {
    flex-grow: 2;
    max-width: unset;
    font-size: 9px;
    margin-top: 5px;
    text-align: center;
    padding: 0px 8px;
  }
`

export const CalendarFinalTitle = styled.div`
  text-align: center;
  width: 100%;
  height: 22px;
  color: ${WHITE};
  background-color: ${RED};
  text-transform: uppercase;
  padding: 4px 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 4px 8px;
  font-size: 12px;
  @media (max-width: 698px) {
    height: 18px;
    font-size: 10px;
    padding: 0px 4px;
  }
`

export const CalendarDay = styled.div`
  width: 100%;
  font-size: 36px;
  font-weight: bold;
  color: ${GRAY_DARK};
  display: flex;
  justify-content: center;
  align-items: center;
  height: calc(100% - 20px);
  @media (max-width: 698px) {
    font-size: 20px;
  }
`

export const DatesContainer = styled.div`
  display: flex;
  flex-flow: column;
  padding-top: ${({ onDemandMode }: DivProps) => (onDemandMode ? '0' : '20px')};
  justify-content: flex-end;
  align-items: center;
  margin: 0;
  @media (max-width: 425px) {
    justify-content: center;
    margin-top: 18px;
  }
`

export const DatesMobileContainer = styled.div`
  display: none;
  @media (max-width: 698px) {
    display: block;
    width: 100%;
    background-color: #f7f7f7;
    padding: 6px 0px;
  }
`

export const Dates = styled.div`
  display: flex;
  flex-flow: row;
  align-items: flex-start;
  @media (max-width: 698px) {
    align-items: center;
  }
`

export const DateTitleContainer = styled.div<{$shrink?: boolean}>`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  flex-grow: 2;
  gap: 2px;
  padding-bottom: 6px;
  ${props => props.$shrink ? `width: 70%` : ''};
`

export const FlexContainer = styled.div`
  position: relative;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  margin-bottom: ${({ secondary }: DivProps) => secondary ? '12px' : '0px'};
  @media (max-width: 914px) {
    align-items: flex-start;
    flex-wrap: wrap;
    justify-content: space-between;
  }
  @media (max-width: 764px) {
    flex-flow: column;
    justify-content: center;
    align-items: center;
  }
  @media (max-width: 698px) {
    align-items: start;
  }
`

export const ReminderDiv = styled.div`
  display: flex;
  align-items: center;
  white-space: nowrap;
  justify-content: center;
  margin-top: 14px;
  margin-bottom: -3px;
  margin-left: 30px;
  transition: all .25s;
  border: 1px solid ${({ secondary }: DivProps) => secondary ? '#005dba38' : '#dedede'};
  padding: 2px 20px;
  border-radius: 25px;
  box-shadow: 1px 2px 4px -1px #e5e5e5;
  ${({ special }: DivProps) => !special ? `
    margin-right: 42px;
    margin-bottom: 6px;
    margin-top: 0px;
  ` : ''}
  &:hover {
    cursor: pointer;
    opacity: 0.8;
    border-color: ${BLUE};
  }
  @media (max-width: 764px) {
    margin-top: 16px;
    margin-bottom: -22px;
  }
  @media (max-width: 698px) {
    margin-top: 2px;
    margin-bottom: -8px;
  }
`

export const ReminderText = styled.div`
  font-size: 13px;
  color: ${({ secondary }: DivProps) => secondary ? '#005dba' : '#9a5db7'};
  .ant-spin {
    margin-left: 10px;
    margin-right: -13px;
    margin-top: 2px;
  }
`

export const ReminderIcon = styled.img`
  margin-left: 22px;
  margin-right: -23px;
  margin-top: -3px;
  margin-bottom: -3px;
  border: 1px solid ${({ secondary }: DivProps) => secondary ? '#005dba87' : '#825db770'};
  background: white;
  height: 34px;
  border-radius: 25px;
  padding: 5px;
  background-image: url(https://cdn-icons-png.flaticon.com/64/3445/3445488.png);
  background-size: cover;
  background-position: center;
  background-origin: content-box;
  background-repeat: no-repeat;
  ${({ secondary }: DivProps) => !secondary ? `
    filter: saturate(0.5) grayscale(0.4);
    animation: wobble-hor-bottomIcon 0.8s 1s 2 both;
    @keyframes wobble-hor-bottomIcon {
      0%, 20%, 50%, 80%, 100% {
        transform: translateY(0);
      }
      40% {
        transform: translateY(-15px);
      }
      60% {
        transform: translateY(-7px);
        filter: grayscale(0.7);
      }
    }
  ` : ''}
`

export const FlexColumnContainer = styled.div`
  /* display: flex;
  flex-direction: column; */
  padding: 10px;
  ${({ secondary }: DivProps) => secondary ? `
    @media (max-width: 698px) {
      display: none;
    }
  ` : ''}
`

export const CalendarContainer = styled.div`
  display: flex;
  flex-flow: column;
  justify-content: center;
  align-items: center;
  @media (max-width: 698px) {
    flex-grow: 1;
    flex-flow: row;
    justify-content: flex-end;
    padding: 8px;
  }
`

export const ButtonsContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  position: relative;
  z-index: ${({ closed }: ContainerProps) => closed ? 0 : 3};
  @media (max-width: 764px) {
    flex-flow: row;
  }
  @media (max-width: 698px) {
    display: none;
  }
`

export const RightActions = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  flex-flow: column;
  @media (max-width: 698px) {
    width: 100%;
  }
`

export const CodeDiv = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  @media (max-width: 1140px) {
    flex-flow: column;
  }
  @media (max-width: 740px) {
    margin-top: 4px;
    flex-flow: column;
  }
`

export const PassCodeDiv = styled.div`
  max-width: 148px;
  @media (max-width: 1140px) {
    max-width: 82px;
  }
`

export const CodeLabel = styled.div`
  display: flex;
  background: #f4f4f4;
  padding: 8px 16px;
  border-radius: 25px;
  font-family: Avenir;
  font-size: 12px;
  overflow-wrap: break-word;
  white-space: break-spaces;
  align-items: center;
  @media (max-width: 598px) {
    margin-top: 12px;
    margin-right: 0;
    width: 100%;
    justify-content: center;
  }
`

export const CurrentTitle = styled.div`
  font-weight: 500;
  margin-right: 8px;
`

export const ResetButton = styled.div`
  border: 1px solid red;
  color: red;
  padding: 6px 12px;
  border-radius: 5px;
  margin-left: 12px;
  font-size: 12px;
  box-shadow: 1px 2px 2px 0px #e3e3e3;
  transition: all .25s;
  &:hover {
    cursor: pointer;
    background: ${RED};
    color: ${WHITE};
  }
  @media (max-width: 1140px) {
    margin-top: 12px;
  }
  @media (max-width: 914px) {
    margin-top: 0px;
  }
  @media (max-width: 740px) {
    margin-top: 12px;
  }
`

export const ActionButtons = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  margin-left: 10px;
  z-index: ${({ closed }: ContainerProps) => closed ? 0 : 3};;
`

export const DatesTitle = styled.div`
  color: ${GRAY_DARK};
  font-size: 10px;
  max-width: 170px;
  letter-spacing: 0.15px;
  line-height: 16px;
  text-align: center;
  padding-bottom: 5px;
  font-weight: ${({ onDemandMode }: DivProps) =>
    onDemandMode ? 'bold' : 'normal'};
  @media (max-width: 698px) {
    max-width: unset;
    font-size: 12px;
    padding-right: 8px;
  }
`

export const AssistanceMobileContainer = styled.div`
  display: none;
  @media (max-width: 698px) {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
  }
`

export const IconsMobileContainer = styled.div`
  display: none;
  @media (max-width: 698px) {
    display: flex;
    gap: 20px;
    margin-right: 18px;
  }
`

export const AssistanceDiv = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  width: fit-content;
  margin: auto;
  padding: 10px 25px;
  text-align: center;
  font-size: 16px;
  background-color: #8FD14F;
  color: black;
  border-radius: 8px;
  @media (max-width: 914px) {
    position: unset;
    margin-right: 0;
    margin-left: 0;
    margin-top: 0;
  }
  @media (max-width: 768px) {
    font-size: 10px;
    padding: 10px 18px;
  }
  @media (max-width: 740px) {
    justify-content: center;
    margin-top: 18px;
    position: unset;
  }
  @media (max-width: 698px) {
    background-color: ${BLACK_BG};
    color: ${WHITE};
    margin: 6px 10px;
    border-radius: 4px;
    font-size: 14px;
  }
`

export const SectionLink = styled.a`
  color: white;
  font-weight: 500;
  margin-top: 8px;
  display: block;
  &:hover {
    cursor: pointer;
  }
  @media (max-width: 698px) {
    color: #cee741;
    margin-top: 2px;
    font-size: 12px;
  }
`

export const ChatIcon = styled.img`
  height: 24px;
`

export const ShareIcon = styled.img`
  height: 24px;
`

export const ListContainer = styled.div`
  padding-right: 0;
  max-width: 1440px;
  width: 100%;
  margin: 0 auto;
  margin-top: 28px;
  @media (min-width: 320px) and (max-width: 748px) {
    padding-left: 0;
  }
  .paginator {
    background: #f8f8f8;
    margin-top: -14px;
    padding-block: 24px;
  }
  #loader {
    position: relative;
    height: 0;
    display: flex;
    justify-content: center;
    z-index: 4;
  }
`

export const MoreItemsFloating = styled.div`
  position: fixed;
  bottom: 40px;
  background: #797979b8;
  backdrop-filter: blur(2px);
  z-index: 3;
  right: 20%;
  color: white;
  padding: 6px 10px;
  border-radius: 5px;
  display: flex;
  flex-flow: column;
  box-shadow: 0px 2px 3px 0px darkgray;
  transition: all .25s;
  &:hover {
    cursor: pointer;
    transform: scale(1.03);
    background: #797979ed;
  }
  @media (max-width: 768px) {
    right: calc(50% - 37px);
    bottom: 58px;
  }
  animation: bounce2 1.25s ease 0.25s both;
  @keyframes bounce2 {
    0% {
      opacity: 0;
      transform: translateY(0);
    }
    10% {
      opacity: 1;
    }
    25% {
      transform: translateY(-15px);
    }
    30% {
      transform: translateY(0);
    }
    40% {
      transform: translateY(-7px);
    }
    50%, 100% {
      transform: translateY(0);
    }
    75% {
      transform: translateY(-15px);
    }
    80% {
      transform: translateY(0);
    }
    90% {
      transform: translateY(-7px);
    }
  }
`

export const DownArrow = styled(Icon)`
  background: #585858;
  border-radius: 25px;
  width: fit-content;
  color: #aaf6ff;
  padding: 4px;
  font-size: 12px;
  margin: 0 auto;
  margin-bottom: -14px;
  margin-top: 3px;
  box-shadow: 0px 2px 3px 0px darkgray;
`

export const Loading = styled.div`
  display: flex;
  justify-content: center;
  height: 100vh;
  align-items: center;
`

export const DynamicDropLogo = styled.img`
  width: 150px;
  margin: 15px 0;
  @media (max-width: 698px) {
    width: 120px;
    float: left;
    margin: 10px 0;
    margin-right: 10px;
  }
`

export const TitlePassword = styled.div`
  font-size: 18px;
  font-weight: 600;
  text-transform: uppercase;
  margin-bottom: 16px;
  text-align: left;
  margin-left: 8px;
`

export const PasswordBody = styled.div``

export const PasswordRecomendations = styled.div`
  font-size: 12px;
  margin-bottom: 16px;
  margin-left: 8px;
`

export const InputTitleContainer = styled.div`
  display: flex;
`

export const PhoneInputDiv = styled.div`
  margin-top: 32px;
  @media (max-width: 498px) {
    margin-top: 52px;
  }
  .react-tel-input {
    max-width: 248px !important;
    width: 100% !important;
    margin: 0 auto !important;
  }
`

export const RatesInfo = styled.div`
  margin: 0 auto;
  margin-top: 12px;
  font-size: 11px;
  text-align: center;
  max-width: 180px;
  font-style: italic;
  margin-bottom: 30px;
  @media (max-width: 768px) {
    margin-bottom: 0px;
  }
`

export const Label = styled.div`
  height: 20px;
  margin-left: 12px;
  color: #5f6062;
  font-size: 14px;
  letter-spacing: 0.18px;
  line-height: 19px;
`

export const StyledInput = styled(InputPassword)`
  input {
    border-radius: 25px;
    margin-right: 14px;
    border: none;
    background: #f4f4f4;
    width: 100%;
    height: 32px;
    padding: 6px 16px;
    margin-top: 4px;
    margin-bottom: 16px;
    border-radius: 25px;
    width: 100%;
  }
  .ant-input-suffix {
    top: 38%;
  }
`

export const StyledInputReminder = styled(InputComponent)`
  border-radius: 25px;
  margin-right: 14px;
  border: none;
  background: #f4f4f4;
  width: 100%;
  height: 32px;
  padding: 6px 16px;
  margin-top: 4px;
  margin-bottom: 16px;
  border-radius: 25px;
  width: 100%;
`

export const RequiredSpan = styled.span`
  color: #e61737;
  margin: 0 5px;
`

export const BottomButtons = styled.div`
  display: flex;
  flex-flow: column;
  align-items: center;
  margin-top: 12px;
`

export const SaveButton = styled(Button)`
  width: 100%;
  border-radius: 5px;
  height: 36px;
  border: none;
  box-shadow: 1px 2px 3px -1px #aaaaaa;
  color: ${WHITE};
  background: ${BLUE};
  @media (max-width: 767px) {
    margin-top: 28px;
    width: 100%;
    margin-right: 0;
    height: 50px;
  }
`

export const CloseButton = styled(Button)`
  width: 100%;
  border-radius: 5px;
  height: 36px;
  box-shadow: 1px 2px 4px -1px #d4d4d4;
  margin-top: 12px;
  border: 1px solid #ececec;
`

export const TitleReminder = styled.div`
  display: flex;
  flex-flow: column;
  justify-content: flex-start;
  align-items: center;
  margin-bottom: 18px;
  font-weight: bold;
  font-size: 18px;
  font-family: Avenir;
`

export const ReminderIconTitle = styled.img`
  max-width: 64px;
  margin-bottom: 14px;
`

export const ReminderBody = styled.div``

export const ReminderDesc = styled.div`
  text-align: center;
  margin-bottom: 30px;
`

export const InfoBody = styled.div`
  display: flex;
  flex-flow: column;
  justify-content: center;
  align-items: center;
  margin-left: -38px;
`

export const InfoTitle = styled.div`
  font-weight: bold;
  font-size: 20px;
  text-align: center;
  margin-left: -22px;
`

export const InfoIcon = styled(Icon)`
  margin-right: 12px;
`

export const InfoDescription = styled.div`
  margin-top: 24px;
  font-size: 15px;
  center {
    font-size: 16px;
  }
  ul {
    padding-left: 15px;
    margin-bottom: 0;
    margin-top: 18px;
  }
`

export const RichContainer = styled.div`
  width: 100vw;
  margin-left: -50px;
  margin-top: -30px;
  margin-bottom: 32px;
  @media (max-width: 748px) {
    margin-left: 0px;
    margin-top: -20px;
  }
`

export const QRCodeDiv = styled.div`
  position: absolute;
  top: calc(100% + 16px);
  left: 10px;
  display: none;
  align-items: center;
  box-shadow: 0px 1px 2px 0px gray;
  padding: 4px;
  border-radius: 3px;
  font-family: Avenir;
  padding-right: 10px;
  ${({ secondary }: DivProps) => secondary ? `
    @media (min-width: 1038px) {
      top: unset;
      left: calc(100% + 12px);
      white-space: nowrap;
    }
    @media (min-width: 764px) and (max-width: 1037px) {
      position: unset;
      width: fit-content;
      margin-bottom: -12px;
      margin-top: 12px;
      margin-left: 12px;
    }
  ` : ''}
  transition: all .25s;
  &:hover {
    cursor: pointer;
    background: #cbdeff;
  }
  @media (max-width: 763px) {
    margin-left: 14px;
    position: unset;
  }
`

export const QrCodeIcon = styled.img`
  max-width: 26px;
  margin-right: 8px;
  filter: grayscale(0.5);
`

export const StyledSelectContainer = styled.div`
  margin-top: 8px;
  display: flex;
  justify-content: flex-end;
  margin-top: 6px;
  margin-bottom: -54px;
  align-items: center;
  z-index: 9;
  @media (max-width: 768px) {
    justify-content: center;
    margin-bottom: -20px;
    margin-top: 14px;
    flex-flow: row-reverse;
  }
  @media (max-width: 698px) {
    display: none;
  }
`

export const StyledSelect = styled(Select)`
  width: 200px;
  transition: all .25s;
  & .ant-select-selection {
    border-radius: 8px;
    height: 38px;
    background: ${BLACK_BG};
  }
  .ant-select-selection__rendered {
    line-height: 36px;
    font-size: 13px;
    margin-left: 12px;
    margin-right: 12px;
  }
  .ant-select-selection-selected-value,
  .ant-select-selection__placeholder {
    color: ${WHITE};
  }
 .ant-select-arrow {
   color: ${WHITE};
 }
`

export const ClearButton = styled.div`
  color: ${BLUE};
  margin-right: 16px;
  font-size: 14px;
  transition: all .25s;
  &:hover {
    color: ${RED};
    cursor: pointer;
    opacity: 0.8;
  }
  @media (max-width: 768px) {
    margin-left: 16px;
    margin-right: unset;
  }
`

export const StyledSelectMobileContainer = styled.div`
  display: none;
  @media (max-width: 698px) {
    display: flex;
    flex-direction: column;
  }
`

export const StyledSelectMobileHeader = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
`

export const ShopByCategoryLabel = styled.h6`
  font-size: 16px;
  font-weight: 500;
  padding: 2px 12px;
`

export const SizeRecIcon = styled.img`
  max-width: 24px;
`

export const CategoryScrollableContainer = styled.div`
  display: flex;
  gap: 10px;
  overflow-x: scroll;
  scrollbar-width: none;
  align-items: baseline;
`

export const CategoryContainer = styled.div<{$selected?: boolean}>`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  max-width: 52px;
  :first-child {
    margin-left: 16px;
  }
  :last-child {
    margin-right: 16px;
  }
`

export const CategoryIndicator = styled.img<{$selected?: boolean}>`
  height: 44px;
  width: 44px;
  border-radius: 50%;
  display: inline-block;
  padding: 2px;
  ${props => props.$selected ? `border: solid thin #6495ED` : ''};
`

export const CategoryLabel = styled.span`
  font-size: 10px;
  text-align: center;
`

export const SizeRecAnnouncement = styled.div`
  position: absolute;
  left: calc(50% - 194px);
  top: 0;
  display: flex;
  max-width: 387px;
  height: 136px;
  padding: 19px;
  flex-direction: column;
  align-items: center;
  gap: 12px;
  flex-shrink: 0;
  border-radius: 6px;
  background: #34C759;
  .cta {
    border-radius: 50px;
    padding: 10px 40px;
    border: 1.5px solid #302628;
    background: #302628;
    box-shadow: 0 4px 4px 0 rgba(0, 0, 0, 0.25);
    text-align: center;
    color: #FFF;
    font-feature-settings: 'liga' off, 'clig' off;
    font-family: "Avenir Next";
    font-size: 17px;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
  }
  p {
    color: #000;
    text-align: center;
    font-feature-settings: 'liga' off, 'clig' off;
    font-family: "Avenir Next";
    font-size: 16px;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
  }  
  @media (max-width: 698px) {
    display: none;
  }
`


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--5!./src/components/StoreFrontContent/styledComponents.tsx